<template>
  <export-menu
    :formats="['png', 'pdf', 'print', 'excel']"
    :loading-format="loading ? 'excel' : ''"
    @export="handleExport"
  />
</template>

<script>
import ExportMenu from '../../otp/components/ExportMenu.vue';
import { exportChartAsPNG, exportChartAsPDF, printChart as printHighchart } from '../../otp/utils/chartExport';

export default {
  name: 'RidershipExportMenu',
  components: { ExportMenu },
  props: {
    /**
     * Ref name of the chart component inside the parent, e.g. 'routeChart'.
     * The parent must expose the Highcharts instance via `$refs[chartRef].$refs.chart.chart`.
     */
    chartRef: {
      type: String,
      required: true,
    },
    /**
     * Filename (without extension) for the exported PNG/PDF.
     */
    filename: {
      type: String,
      default: 'ridership-chart',
    },
    /**
     * When true, the Excel menu item shows a spinner and is disabled.
     */
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    // Fixed chart name for Datadog RUM export events
    surface() {
      return `ridership-${this.chartRef}`;
    },
  },
  methods: {
    handleExport(format) {
      if (format === 'png') {
        this.exportAsPNG();
      } else if (format === 'pdf') {
        this.exportAsPDF();
      } else if (format === 'print') {
        this.printChart();
      } else if (format === 'excel') {
        this.$emit('export-excel');
      }
    },
    getChart() {
      const chartComponent = this.$parent?.$refs?.[this.chartRef];
      return chartComponent?.$refs?.chart?.chart || null;
    },
    exportAsPNG() {
      const hc = this.getChart();
      if (!hc) return;
      exportChartAsPNG(hc, this.filename, { surface: this.surface });
    },
    exportAsPDF() {
      exportChartAsPDF(this.getChart(), this.filename, this.surface);
    },
    printChart() {
      printHighchart(this.getChart(), this.surface);
    },
  },
};
</script>

<style scoped>
/* Positioning handled by parent */
</style>
